<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="courseTypeDetails" class="p-2">
          <h1 class="mb-2">ویرایش سطح دوره {{ defaultCourseTypeTitle }}</h1>
          <b-form @submit.prevent v-if="courseTypeDetails">
            <b-form-group label="عنوان سطح دوره" label-for="course-type-title">
              <b-form-input
                id="course-type-title"
                v-model="courseTypeDetails.title"
                trim
                placeholder="ابتدایی"
              />
            </b-form-group>
          </b-form>
          <div class="w-100 mt-3">
            <div class="w-100" v-if="courseTypeProperties">
              <div
                class="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between"
              >
                <h3>ویژگی های سطح دوره</h3>
                <b-button variant="success" @click="addNewCourseTypeProperty">
                  افزودن ویژگی
                </b-button>
              </div>
              <hr />
              <template v-if="courseTypeProperties.length > 0">
                <b-card
                  class="custom-card mb-0"
                  v-for="(item, index) in courseTypeProperties"
                  :key="index"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="mb-0">
                      {{ item.name }}
                    </p>
                    <div class="d-flex align-items-center">
                      <feather-icon
                        @click="renderEditCourseTypePropertyModal(item)"
                        icon="EditIcon"
                        size="20"
                        class="text-primary"
                        style="cursor: pointer"
                      />
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="ml-2 text-danger"
                        style="cursor: pointer"
                        @click="renderDeleteCourseTypePropertyModal(item)"
                      />
                    </div>
                  </div>
                  <hr />
                </b-card>
              </template>
              <template v-else>
                <b-card class="custom-card">
                  <p>هیچ ویژگی برای این سطح وجود ندارد</p>
                </b-card>
              </template>
            </div>
            <div
              class="w-100"
              v-if="
                newCourseTypeProperties && newCourseTypeProperties.length > 0
              "
            >
              <h3>ویژگی های در انتظار ایجاد</h3>
              <hr />
              <b-card
                v-for="(item, index) in newCourseTypeProperties"
                :key="index"
                class="mb-0 custom-card"
              >
                <b-form @submit.prevent>
                  <b-form-group
                    label="نام ویژگی سطح دوره"
                    :label-for="`course-type-${index}`"
                  >
                    <div
                      class="w-100 d-flex align-items-center justify-content-between"
                    >
                      <b-form-input
                        :state="item.name && item.name != '' ? true : false"
                        :id="`course-type-${index}`"
                        v-model="item.name"
                        trim
                        placeholder="پشتیبانی یا ..."
                      />
                      <feather-icon
                        @click="deleteNewlyAddedProperties(item)"
                        icon="Trash2Icon"
                        size="20"
                        class="ml-1 text-danger"
                        style="cursor: pointer"
                      />
                    </div>
                  </b-form-group>
                </b-form>
                <hr />
              </b-card>
            </div>
            <div class="w-100 d-flex align-items-center justify-content-end">
              <b-button variant="primary" @click="sendUpdateRequest">
                بروزرسانی
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      centered
      id="property-delete"
      title="حذف یک ویژگی سطح دوره"
      ok-title="حذف"
      cancel-title="بستن"
      @ok="sendCourseTypePropertyDeleteRequest"
      @cancel="clearTempPropertyObject"
    >
      <p v-if="tempPropertyObject">
        آیا از حذف ویژگی سطح دوره ({{ tempPropertyObject.name }}) اطمینان دارید؟
      </p>
    </b-modal>
    <b-modal
      centered
      id="property-edit"
      title="ویرایش ویژگی سطح دوره"
      ok-title="بروزرسانی"
      cancel-title="بستن"
      @ok="sendUpdatePropertyRequest"
      @cancel="clearTempPropertyObject"
    >
      <b-form class="p-2" @submit.prevent v-if="tempPropertyObject">
        <b-form-group label="نام ویژگی سطح دوره" label-for="lang">
          <b-form-input v-model="tempPropertyObject.name"></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </b-overlay>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import {
  GetCourseType,
  UpdateACourseType,
} from "../../../../libs/Api/CourseType";
import {
  CreateCourseTypeProperties,
  GetAllCourseTypeProperties,
  UpdateCourseTypeProperty,
  DeleteCourseTypeProperty,
} from "../../../../libs/Api/CourseTypeProperty";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import helper from "@/libs/Helper";

export default {
  data() {
    return {
      isLoading: false,
      defaultCourseTypeTitle: null,
      courseTypeDetails: null,
      newCourseTypeProperties: [],
      courseTypeProperties: [],
      tempPropertyObject: null,
    };
  },
  mounted() {
    this.getCourseType();
    this.getAllCourseTypePropertiesForThisCourse();
  },
  methods: {
    deleteNewlyAddedProperties(property) {
      this.newCourseTypeProperties = this.newCourseTypeProperties.filter(
        (item) => item != property
      );
    },
    async renderDeleteCourseTypePropertyModal(item) {
      this.tempPropertyObject = JSON.parse(JSON.stringify(item));
      this.$bvModal.show("property-delete");
    },
    async sendCourseTypePropertyDeleteRequest() {
      try {
        let _this = this;
        let deleteCourseTypeProperty = new DeleteCourseTypeProperty(_this);
        deleteCourseTypeProperty.setRequestParam({
          id: _this.tempPropertyObject.courseTypePropertyId,
        });
        await deleteCourseTypeProperty.fetch(
          function (response) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف با موفقیت انجام شد",
                icon: "XIcon",
                variant: "success",
              },
            });
            _this.getAllCourseTypePropertiesForThisCourse();
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    generateCreateErrorMessages(namesArray) {
      let stringOfNames = "";
      for (let i = 0; i < namesArray.length; i++) {
        if (i != namesArray.length - 1) {
          stringOfNames += `${namesArray[i]} - `;
        } else {
          stringOfNames += `${namesArray[i]}`;
        }
      }
      return `ویژگی های (${stringOfNames}) تکراری هستند.`;
    },
    clearTempPropertyObject() {
      this.tempPropertyObject = null;
    },
    async sendUpdatePropertyRequest() {
      try {
        let _this = this;
        let updateCourseTypeProperty = new UpdateCourseTypeProperty(_this);
        updateCourseTypeProperty.setRequestParamDataObj(
          _this.tempPropertyObject
        );
        await updateCourseTypeProperty.fetch(
          function (response) {
            if (
              response &&
              response.message &&
              response.message == "OperationSucceeded"
            ) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "ویرایش با موفقیت انجام شد",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              _this.getAllCourseTypePropertiesForThisCourse();
            } else if (response == "DuplicatedRecord") {
              // console.log(response);
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `توجه`,
            icon: "XIcon",
            variant: "danger",
            text: `این نام تکراری است`,
          },
        });
      }
    },
    renderEditCourseTypePropertyModal(item) {
      this.tempPropertyObject = JSON.parse(JSON.stringify(item));
      this.$bvModal.show("property-edit");
    },
    async getAllCourseTypePropertiesForThisCourse() {
      try {
        let _this = this;
        let getAllCourseTypeProperties = new GetAllCourseTypeProperties(_this);
        getAllCourseTypeProperties.setRequestParam({
          count: 0,
          pageNumber: 0,
          courseTypeId: _this.$route.params.id,
        });
        getAllCourseTypeProperties.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.courseTypeProperties = response.data.courseTypeProperties;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    async createCourseTypePropertyList() {
      let hasError = false;
      this.newCourseTypeProperties.forEach((item) => {
        if (!item.name) {
          hasError = true;
        }
      });
      if (!hasError) {
        let _this = this;
        let createCourseTypeProperties = new CreateCourseTypeProperties(_this);
        createCourseTypeProperties.setRequestParamDataObj(
          _this.newCourseTypeProperties
        );
        await createCourseTypeProperties.fetch(
          function (response) {
            if (
              response &&
              response.isSuccess &&
              response.data.creationErrorMessages &&
              response.data.creationErrorMessages.length > 0
            ) {
              let namesArray = helper.handlePropertyCreateListError(
                response.creationErrorMessages
              );
              _this.$toast({
                component: ToastificationContent,
                position: "bottom-center",
                props: {
                  title: `توجه`,
                  icon: "XIcon",
                  variant: "danger",
                  text: _this.generateCreateErrorMessages(namesArray),
                },
              });
            }
            if (
              response &&
              response.isSuccess &&
              response.data.creationRecordsCount &&
              response.data.creationRecordsCount > 0
            ) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${response.creationRecordsCount} ویژگی جدید با موفقیت ساخته شد`,
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
              _this.getAllCourseTypePropertiesForThisCourse();
              _this.newCourseTypeProperties = [];
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `توجه`,
            icon: "XIcon",
            variant: "danger",
            text: "نام ویژگی سطح دوره نباید خالی باشد",
          },
        });
      }
    },
    async sendUpdateRequest() {
      try {
        this.isLoading = true;
        if (this.courseTypeDetails.title != this.defaultCourseTypeTitle) {
          let _this = this;
          let updateACourseType = new UpdateACourseType(_this);
          updateACourseType.setRequestParamDataObj(_this.courseTypeDetails);
          await updateACourseType.fetch(
            async function (response) {
              _this.getCourseType();
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "ویرایش با موفقیت انجام شد",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            },
            function (error) {
              console.error(error);
            }
          );
        }
        if (
          this.newCourseTypeProperties &&
          this.newCourseTypeProperties.length > 0
        ) {
          await this.createCourseTypePropertyList();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    addNewCourseTypeProperty() {
      this.newCourseTypeProperties.push({
        isDeleted: false,
        courseTypePropertyId: 0,
        courseTypeId: this.$route.params.id,
        name: null,
      });
    },
    async getCourseType() {
      try {
        let _this = this;
        let getCourseType = new GetCourseType(_this);
        getCourseType.setRequestParam({
          id: _this.$route.params.id,
        });
        await getCourseType.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.courseTypeDetails = response.data;
              _this.defaultCourseTypeTitle = JSON.parse(
                JSON.stringify(response.data.title)
              );
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
<style scoped>
.custom-card .card-body {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
